export default function ToggleField({ label, checked, onChange, disabled, hint }) {
  return (
    <div className="form-field">
      <div className="toggle-wrap">
        <label className="toggle">
          <input
            type="checkbox"
            checked={!!checked}
            onChange={e => onChange(e.target.checked)}
            disabled={disabled}
          />
          <span className="toggle-track" />
        </label>
        {label && <span className="toggle-label">{label}</span>}
      </div>
      {hint && <span className="form-hint">{hint}</span>}
    </div>
  );
}
